function o(r, e) {
  return "".concat(n(r)).concat(e);
}
var a = 26;
function n(r) {
  if (typeof r != "number")
    return "";
  var e = Math.floor(r / a), t = String.fromCharCode(97 + r % a).toUpperCase();
  return e === 0 ? t : n(e - 1) + t;
}
export {
  o as default
};
//# sourceMappingURL=index.es300.js.map
